var app = angular.module('leonardo');

var AccountInvitationService = function(BaseRestService) {
  var service = new BaseRestService('account-invitations', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('account-invitations', false, function (invitation) {
      invitation.addRestangularMethod('accept', 'post', 'accept');
      invitation.addRestangularMethod('decline', 'post', 'decline');
      return invitation;
    });
  });

  service.STATUS_PENDING = '0';
  service.STATUS_ACCEPTED = '1';
  service.STATUS_DECLINED = '2';
  service.STATUS_LOADING = '3';

  service.STATUS_OPTIONS = [
    {
      id: service.STATUS_PENDING,
      name: 'Pending'
    },
    {
      id: service.STATUS_ACCEPTED,
      name: 'Accepted'
    },
    {
      id: service.STATUS_DECLINED,
      name: 'Declined'
    },
    {
      id: service.STATUS_LOADING,
      name: 'Loading'
    }
  ];

  return service;
};

app.factory('AccountInvitationService', ['BaseRestService', AccountInvitationService]);
